<div class="container">
    <section class="hero">
        <div class="header-logos">
            <a href="https://cabruca.com.br/" target="_blank" rel="noopener noreferrer">
                <img src="../../../assets/images/cabruca/cabruca-logo.png" alt="logo-cabruca">
                <span> CABRUCA </span>
            </a>
        </div>
        <div style="display: flex; flex-direction: column; align-items: center; gap: 10px;">
            <h1>BEM VINDO AO <span class="conectar"> QIMA SAFE! </span></h1>
            <div class="inform-container">
                <p class="inform"> Código de Rastreamento </p>
            </div>
            <div class="search-bar">
                <form [formGroup]="form">
                    <input [ngClass]="form.get('code')?.value ? 'disabled' : ''" type="text" id="code" name="code"
                        placeholder="Insira o código do produto para rastreá-lo" formControlName="code" />
                    <button [ngClass]="form.get('code')?.value ? 'disabled' : ''"
                        style="margin-right: 0%; border: none">
                        <img src="../../../assets/images/cabruca/search-icon.svg" alt="Search Icon" />
                    </button>
                </form>
            </div>
        </div>
    </section>

    <section class='traceability' #traceabilitySection>
        <div class="title-container">
            <div>
                <h2> Rastreabilidade </h2>
            </div>
        </div>

        <div class="card-container">
            @if(cabrucaData && cabrucaData.length > 0){
            <div class="card info-card">
                <p> Detalhamento de Informações </p>
                <div class="carousel-container">
                    <img [src]="productImages[currentIndex]" alt="Imagem do produto">
                    @if (productImages.length > 1) {
                    <button class="controls back-image" (click)="prevImage()" [disabled]="productImages.length <= 1">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="-150 -960 960 960" width="24px"
                            fill="#BCCB50">
                            <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
                        </svg>
                    </button>

                    <button class="controls forward-image" (click)="nextImage()" [disabled]="productImages.length <= 1">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                            fill="#BCCB50">
                            <path d="m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z" />
                        </svg>
                    </button>
                    }
                </div>
                <div style="display: flex; flex-direction: column; align-items: start;">
                    <span class="description"> Código de Rastreamento: </span>
                    <span class="code"> {{ identifier }} </span>
                </div>
                <div style="display: flex; align-items: center; gap: 12px;">
                    @if(activeUrl === 'cacau'){
                    <span class="description">
                        O cacau é amplamente valorizado por suas propriedades antioxidantes e por ser uma fonte
                        natural
                        de energia, além de conter minerais como magnésio e ferro, contribuindo para o bem-estar e a
                        saúde cardiovascular.
                    </span>
                    }
                    @if(activeUrl === 'chocolate'){
                    <span class="description">
                        O chocolate, derivado do cacau, é apreciado mundialmente por seu sabor inconfundível e
                        também
                        pode oferecer benefícios à saúde, especialmente na forma amarga, sendo rico em flavonoides
                        que
                        auxiliam na melhoria do humor e na proteção do sistema cardiovascular.
                    </span>
                    }
                    <button (click)="openModal(1)">
                        <img src="../../../assets/images/cabruca/info-icon.svg" alt="information-icon">
                    </button>
                </div>
            </div>
            }

            <div class="card caminho-card" style="height: auto;">
                <p> Caminho percorrido pelo produto </p>

                <div id="map" #mapArea *ngIf="!isModalOpen">
                    <link rel="stylesheet" href="https://unpkg.com/leaflet/dist/leaflet.css" />
                    <link rel="stylesheet" href="https://unpkg.com/leaflet-editable/doc/style.css" />
                    <link rel="stylesheet" href="https://unpkg.com/leaflet-draw@1.0.4/dist/leaflet.draw.css" />
                    <script src="https://unpkg.com/leaflet/dist/leaflet.js"></script>
                    <script src="https://unpkg.com/leaflet-providers@1.12.0/leaflet-providers.js"></script>
                </div>

                <div class="info-map-container">
                    <img src="../../../assets/images/cabruca/Origin-Location.svg" alt="location-icon">
                    <div style="display: flex; flex-direction: column; gap: 6px;">
                        <span class="name"> ORIGENS DECLARADAS ({{ origins[0]?.origins?.length || '0' }}) </span>
                    </div>
                    <button (click)="openModal(2)">
                        <img src="../../../assets/images/cabruca/info-icon.svg" alt="information-icon">
                    </button>
                </div>
                <div class="info-map-container">
                    <img src="../../../assets/images/cabruca/Distributor-Location.svg" alt="location-icon">
                    <div style="display: flex; gap: 6px;">
                        <span class="name"> ÚLTIMO DESTINO: <span class="company-name"> {{ lastOriginName ? lastOriginName : 'Indisponível' }} </span> </span>
                    </div>
                    <button (click)="openModal(3)">
                        <img src="../../../assets/images/cabruca/info-icon.svg" alt="information-icon">
                    </button>
                </div>
            </div>
        </div>
    </section>

    <!-- Modais -->
    <ng-template [ngIf]="isModalOpen && currentModal === 1">
        <div class="modal">
            <div class="modal-content">
                <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                    @if(activeUrl){
                    <h2> {{ cabrucaData![0].invoiceItem!.product.name }} </h2>
                    }
                    <button (click)="closeModal()">
                        <img src="../../../assets/images/cabruca/close-icon.svg" alt="close-icon">
                    </button>
                </div>

                @if(activeUrl === 'cacau'){
                <span>
                    O cacau é amplamente valorizado por suas propriedades antioxidantes e por ser uma fonte natural
                    de energia, além de conter minerais como magnésio e ferro, contribuindo para o bem-estar e a
                    saúde cardiovascular.
                </span>
                }

                @if(activeUrl === 'chocolate'){
                <span>
                    O chocolate, derivado do cacau, é apreciado mundialmente por seu sabor inconfundível e também
                    pode oferecer benefícios à saúde, especialmente na forma amarga, sendo rico em flavonoides que
                    auxiliam na melhoria do humor e na proteção do sistema cardiovascular.
                </span>
                }
                <p>Característica do produto</p>

                @if(activeUrl === 'cacau'){
                <ul>
                    <li>
                        Seleção das Melhores Espécies: Nosso cacau é cultivado por produtores dedicados que utilizam o
                        sistema agroflorestal tradicional conhecido como "cabruca", onde os cacaueiros crescem à sombra
                        de árvores nativas da Mata Atlântica. Esse método não apenas preserva a biodiversidade local,
                        mas também garante frutos de alta qualidade para a produção de chocolates finos.
                    </li>
                    <li>
                        Produzidos nas Melhores Condições: As fazendas associadas à Cooperativa CABRUCA estão
                        localizadas no sul da Bahia, uma região com condições climáticas ideais para o cultivo do cacau.
                        O cultivo sob a sombra das árvores nativas proporciona um ambiente propício para o
                        desenvolvimento saudável dos cacaueiros, resultando em amêndoas de cacau com sabores e aromas
                        distintos.
                    </li>
                    <li>
                        Produção Sustentável: Comprometidos com a sustentabilidade, nossos produtores adotam práticas
                        orgânicas e biodinâmicas certificadas. Essas técnicas minimizam o impacto ambiental e promovem a
                        conservação dos ecossistemas florestais, assegurando que a produção de cacau contribua para a
                        preservação da Mata Atlântica e para o bem-estar das comunidades locais.
                    </li>
                </ul>
                }
                @if(activeUrl === 'chocolate'){
                <ul>
                    <li>
                        Excelência na Origem: O chocolate produzido com cacau da Cabruca carrega em sua essência a
                        riqueza da Mata Atlântica. Originado de amêndoas selecionadas cultivadas em sistemas
                        agroflorestais, ele reflete o cuidado e o respeito à natureza desde a lavoura até a barra.
                    </li>
                    <li>
                        Qualidade Artesanal: Nossos chocolates são produzidos por marcas que valorizam o processo
                        bean-to-bar, ou seja, da amêndoa à barra. Isso garante um controle de qualidade rigoroso em cada
                        etapa, resultando em chocolates com sabor único, textura refinada e alto teor de cacau.
                    </li>
                    <li>
                        Compromisso com Sustentabilidade e Comunidade: A produção de chocolate com cacau Cabruca
                        incentiva a agricultura regenerativa, protege a biodiversidade e fortalece os pequenos
                        produtores locais. Ao escolher esses chocolates, você apoia um modelo de produção justo,
                        ecológico e socialmente responsável.
                    </li>
                </ul>
                }

                <p>Variedades:</p>

                @if(activeUrl === 'cacau'){
                <span>
                    Trabalhamos com uma rica diversidade de variedades de cacau cultivadas de forma agroflorestal no sul
                    da Bahia, incluindo tipos nativos e híbridos selecionados ao longo de gerações. Cada variedade
                    possui perfis sensoriais distintos — com nuances que vão do frutado ao amendoado —, permitindo a
                    criação de chocolates sofisticados e únicos. Essa diversidade atende diferentes demandas do mercado
                    bean-to-bar e valoriza o terroir da Mata Atlântica.
                </span>
                }

                @if(activeUrl === 'chocolate'){
                <span>
                    Nossos chocolates refletem a diversidade de sabores do cacau Cabruca, oferecendo uma linha que vai
                    desde barras com alto teor de cacau, mais intensas e complexas, até versões mais suaves com
                    inclusões naturais, como frutas e castanhas da região. Cada chocolate carrega em si a expressão do
                    tipo de amêndoa utilizada, permitindo que o consumidor experimente diferentes experiências
                    sensoriais em cada produto.
                </span>
                }

                <p>Sazonalidade:</p>

                @if(activeUrl === 'cacau'){
                <span>
                    Sazonalidade:
                    Graças ao sistema agroflorestal e à experiência dos produtores da Cabruca, o cacau é cultivado
                    respeitando os ciclos naturais da planta, o que permite uma produção estável e de qualidade durante
                    todo o ano. A diversificação nas áreas de plantio e o manejo sustentável garantem a oferta contínua
                    de amêndoas frescas, sem comprometer o equilíbrio ecológico da Mata Atlântica.
                </span>
                }

                @if(activeUrl === 'chocolate'){
                <span>
                    Sazonalidade:
                    A produção de chocolate com cacau Cabruca acompanha a regularidade das safras e o abastecimento
                    constante das amêndoas, o que assegura a disponibilidade de chocolates artesanais o ano inteiro.
                    Esse fluxo contínuo permite que os fabricantes ofereçam produtos sempre frescos, mantendo o sabor, a
                    qualidade e a origem sustentável em todas as estações.
                </span>
                }

                <p>Produção:</p>

                @if(activeUrl === 'cacau'){
                <span>
                    Produção:
                    Garantimos a origem e a qualidade do nosso cacau, cultivado por produtores que seguem práticas
                    agroflorestais tradicionais, livres de agrotóxicos e respeitando os princípios da agricultura
                    orgânica. O manejo do cacaueiro é feito de forma cuidadosa, promovendo a saúde da planta e a
                    conservação do solo, com foco na biodiversidade e na preservação da Mata Atlântica. Cada etapa,
                    desde o cultivo até a secagem das amêndoas, é realizada com rigor técnico e responsabilidade
                    ambiental, assegurando um cacau de excelência e com rastreabilidade garantida.
                </span>
                }

                @if(activeUrl === 'chocolate'){
                <span>
                    Nossos chocolates são produzidos a partir de amêndoas de cacau selecionadas, com origem garantida e
                    manejo sustentável. As marcas parceiras adotam o processo artesanal "bean to bar", que preserva as
                    características naturais do cacau e permite o controle de qualidade em todas as etapas — da
                    fermentação ao refinamento. Sem aditivos artificiais e com foco em ingredientes naturais e frescos,
                    cada chocolate carrega o compromisso com a pureza, a sustentabilidade e o sabor autêntico,
                    respeitando tanto o meio ambiente quanto os pequenos produtores envolvidos.
                </span>
                }
            </div>
        </div>
    </ng-template>

    <ng-template [ngIf]="isModalOpen && currentModal === 2">
        <div class="modal">
            <div class="modal-content">
                <div class="modal-content-header">
                    <h2 style="margin-bottom: 6px;"> Mais Informações sobre o Produto de Origem </h2>
                    <button (click)="closeModal()">
                        <img src="../../../assets/images/cabruca/close-icon.svg" alt="close-icon">
                    </button>
                </div>
                <div class="origins-container">
                    <li class="name" style="margin-bottom: 2%;"> ORIGENS DECLARADAS </li>
                    @for(company of origins; track $index) {
                    <div class="origin">
                        <span class="company-name">
                            <button class="expand-button" (click)="toggleExpandOrigin($index, 'origin')">
                                <svg [ngClass]="{'rotated': expandedOrigins[$index]}" xmlns="http://www.w3.org/2000/svg"
                                    height="24px" viewBox="0 -960 960 960" width="24px" fill="rgb(137, 40, 28)">
                                    <path d="M400-280v-400l200 200-200 200Z" />
                                </svg>
                            </button>
                            {{ company.productName }}
                        </span>
                        <div class="origins-list" [ngClass]="{'expanded': expandedOrigins[$index]}">
                            @for(origin of company.origins; track origin;) {
                            <div class="location-container">
                                <li class="location"> {{ origin.customer }} </li>
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
                                    width="24px" fill="rgb(137, 40, 28)">
                                    <path d="m700-300-57-56 84-84H120v-80h607l-83-84 57-56 179 180-180 180Z" />
                                </svg>
                                <span class="location"> {{ origin.provider }} </span>
                                <svg style="margin-left: 10px;" xmlns="http://www.w3.org/2000/svg" height="12px"
                                    viewBox="0 -960 960 960" width="12px" fill="rgb(137, 40, 28)">
                                    <path
                                        d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Zm280 240q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z" />
                                </svg>
                                <span class="location"> ({{ formatDate(origin.date) || 'Sem data informada'}}) </span>
                            </div>
                            }
                        </div>
                    </div>
                    }
                </div>
                <div style="display: flex; flex-direction: column; align-items: start; gap: 24px;">
                    <span> {{ activeUrl === 'cacau' ? 'Produção de cacau de qualidade, priorizamos sempre a
                        sustentabilidade e o equilíbrio ambiental.' : activeUrl === 'chocolate' ? 'Produção de chocolate
                        de origem, priorizamos sempre a pureza dos ingredientes e o respeito ao produtor.' : '' }}
                    </span>

                    @if(activeUrl === 'cacau'){
                    <img src="../../../assets/images/cabruca/cacau-modal2.jpeg" alt="modal-cacau-origin">
                    }

                    @if(activeUrl === 'chocolate'){
                    <img src="../../../assets/images/cabruca/chocolate-modal2.jpeg" alt="modal-chocolate-origin">
                    }
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template [ngIf]="isModalOpen && currentModal === 3">
        <div class="modal">
            <div class="modal-content">
                <div style="display: flex; align-items: last baseline; justify-content: space-between;">
                    <h2> Mais Informações sobre o Distribuidor </h2>
                    <button (click)="closeModal()">
                        <img src="../../../assets/images/cabruca/close-icon.svg" alt="close-icon">
                    </button>
                </div>

                <div class="origins-container">
                    <li class="name" style="margin-bottom: 2%;"> ÚLTIMOS DESTINOS </li>
                    @for(company of origins; track $index) {
                    <div class="origin">
                        <span class="company-name">
                            <button class="expand-button" (click)="toggleExpandOrigin($index, 'lastOrigin')">
                                <svg [ngClass]="{'rotated': expandedLastOrigins[$index]}"
                                    xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
                                    width="24px" fill="rgb(137, 40, 28)">
                                    <path d="M400-280v-400l200 200-200 200Z" />
                                </svg>
                            </button>
                            {{ company.productName }}
                        </span>
                        <div class="origins-list" [ngClass]="{'expanded': expandedLastOrigins[$index]}">
                            <div class="location-container">
                                <li class="location"> {{ getLastMovement(company.productName, 'provider') }} </li>
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
                                    width="24px" fill="rgb(137, 40, 28)">
                                    <path d="m700-300-57-56 84-84H120v-80h607l-83-84 57-56 179 180-180 180Z" />
                                </svg>
                                <span class="location"> {{ getLastMovement(company.productName, 'customer') }} </span>
                                <svg style="margin-left: 10px;" xmlns="http://www.w3.org/2000/svg" height="12px"
                                    viewBox="0 -960 960 960" width="12px" fill="rgb(137, 40, 28)">
                                    <path
                                        d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Zm280 240q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z" />
                                </svg>
                                <span class="location"> ({{ formatDate(getLastMovement(company.productName, 'date')) ||
                                    'Sem data informada'}}) </span>
                            </div>
                        </div>
                    </div>
                    }
                </div>

                @if(activeUrl === 'cacau'){
                <img src="../../../assets/images/cabruca/cacau-modal3.jpeg" style="margin-top: 5%;"
                    alt="modal-cacau-origin">
                }

                @if(activeUrl === 'chocolate'){
                <img src="../../../assets/images/cabruca/chocolate-modal3.jpeg" style="margin-top: 5%;"
                    alt="modal-chocolate-origin">
                }
            </div>
        </div>
    </ng-template>

    <footer>
        <div id="copyright">
            <span> Powered by </span>
            <svg width="100px" height="70%" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22.8469 0.0661697C17.1623 0.559517 12.405 2.61713 8.29806 6.33527C0.349165 13.567 -1.78258 25.287 3.10719 34.8771C6.80463 42.1329 13.8502 46.9822 21.9678 47.8606C29.1097 48.6427 36.3601 46.1038 41.4546 41.0139C42.6951 39.7865 44.3571 37.765 44.2728 37.6206C44.2367 37.5605 43.1528 37.5244 41.852 37.5244H39.5035L38.3473 38.5833C35.8542 40.8454 33.6984 42.1329 30.8079 43.0835C26.5926 44.4673 22.2327 44.4312 17.9813 42.9873C12.6097 41.1583 8.04514 36.8987 5.97361 31.7727C3.67325 26.0691 3.89004 20.2452 6.62397 14.8425C8.23784 11.6297 11.6221 8.15223 14.8378 6.39544C19.2218 4.0009 24.6535 3.32707 29.5553 4.56645C35.1196 5.96226 40.0936 10.0294 42.6228 15.2396C42.936 15.8653 43.213 16.3105 43.2491 16.2142C43.2732 16.118 43.6586 14.9748 44.1042 13.6633L44.8991 11.2687L44.309 10.4144C42.3338 7.55059 39.4192 4.85524 36.4323 3.15861C32.494 0.920502 27.1225 -0.306847 22.8469 0.0661697Z"
                    fill="white" />
                <path
                    d="M28.0979 12.4722C27.3632 12.8452 27.014 13.5792 27.0019 14.7825V15.324H26.5563H26.0986L26.0625 16.3107L26.0264 17.3094H26.5081H27.0019L27.026 20.3417L27.0621 23.386H28.0859H29.1096L29.1457 20.3417L29.1698 17.3094H29.8322H30.4946V16.2866V15.2759L29.9888 15.312C29.2541 15.3601 29.1698 15.2999 29.1698 14.7705C29.1698 14.1568 29.5552 13.8801 30.2537 14.0004L30.7355 14.0846V13.2904C30.7355 12.5444 30.7114 12.4842 30.4223 12.3759C29.9165 12.1714 28.5556 12.2316 28.0979 12.4722Z"
                    fill="white" />
                <path
                    d="M43.6944 19.4633C42.5262 22.9648 41.5747 25.8648 41.5747 25.9009C41.5747 25.937 42.2371 25.9851 43.044 25.9971L44.5254 26.0332L44.4893 26.4544C44.4652 26.683 44.4411 26.9838 44.4291 27.1162C44.405 27.3448 44.4893 27.3568 46.3561 27.3929L48.3072 27.417L48.4035 26.9718C48.4517 26.7191 48.4999 25.3233 48.4999 23.8673C48.4878 20.8832 48.3072 19.6318 47.5243 17.0688C47.0908 15.6609 46.0309 13.0979 45.8864 13.0979C45.8503 13.0979 44.8627 15.9617 43.6944 19.4633Z"
                    fill="white" />
                <path
                    d="M13.3078 15.2639C11.9349 15.5527 11.3086 16.2145 11.2484 17.4298C11.1761 18.8376 11.8746 19.5476 13.9703 20.1973C14.5965 20.3899 15.2108 20.6426 15.3432 20.7509C15.6443 21.0396 15.6203 21.3645 15.2589 21.5932C14.8254 21.8819 13.4162 21.7616 12.4166 21.3525C11.9951 21.184 11.6458 21.0637 11.6458 21.0757C11.5374 21.2683 10.9834 22.5919 10.9834 22.64C10.9834 22.7363 12.1276 23.1935 12.8622 23.386C14.1991 23.735 15.813 23.5545 16.7042 22.9529C17.5232 22.3994 17.8363 21.1359 17.4268 20.1011C17.1378 19.3911 16.4031 18.9219 14.6447 18.3443C13.5728 17.9953 13.1995 17.7065 13.3319 17.3215C13.4765 16.8522 14.8374 16.8402 16.0779 17.3095C16.4151 17.4418 16.7283 17.502 16.7644 17.4539C16.8126 17.4057 16.9692 17.0447 17.1137 16.6597C17.4148 15.8294 17.4389 15.8655 16.2827 15.5045C15.3914 15.2158 14.0305 15.1075 13.3078 15.2639Z"
                    fill="white" />
                <path
                    d="M20.6432 15.3119C19.8483 15.5165 19.0534 15.8654 19.0534 16.0219C19.0534 16.082 19.222 16.4189 19.4147 16.7799L19.7881 17.4177L20.2216 17.2372C20.4625 17.1289 20.9443 17.0086 21.2935 16.9484C22.4377 16.7559 23.1483 17.1529 23.1483 17.9832V18.3683L22.7026 18.1998C21.7151 17.8509 20.0891 18.1035 19.3063 18.7292C18.0778 19.6919 18.0056 21.557 19.1377 22.688C20.0169 23.5785 21.4983 23.7951 22.6424 23.2175C23.1121 22.9768 23.1242 22.9768 23.1844 23.2055C23.2326 23.41 23.353 23.4221 24.2442 23.41L25.2559 23.386V20.4981C25.2559 18.9097 25.2078 17.4056 25.1596 17.1529C25.0391 16.5633 24.3286 15.7692 23.6661 15.4804C22.9917 15.1916 21.4742 15.0953 20.6432 15.3119ZM22.7749 19.8483C23.1483 19.9807 23.1603 20.0047 23.1242 20.5943C23.076 21.3524 22.7267 21.6532 21.7873 21.7375C21.2453 21.7856 21.1008 21.7495 20.8118 21.5088C20.3059 21.0757 20.3541 20.1251 20.8961 19.8603C21.2453 19.6919 22.2932 19.6798 22.7749 19.8483Z"
                    fill="white" />
                <path
                    d="M33.4577 15.2759C32.8074 15.4323 32.2774 15.7813 31.6993 16.431C30.5191 17.7787 30.3986 20.3778 31.4585 22.0383C32.5304 23.735 35.3245 24.0598 36.9745 22.664C37.4201 22.291 37.4201 22.279 36.5048 21.5089C35.9508 21.0396 35.9147 21.0396 35.6377 21.2201C35.1318 21.545 34.5899 21.6412 34.0358 21.5089C33.4457 21.3525 33.0603 21.0035 32.9158 20.462L32.8074 20.077L35.2282 20.0529L37.661 20.0168L37.649 19.1745C37.6369 17.5381 36.9504 16.2024 35.8063 15.5887C35.1077 15.2037 34.2045 15.0834 33.4577 15.2759ZM34.6139 17.0688C34.8669 17.141 35.1559 17.3335 35.2884 17.526C35.5293 17.875 35.6979 18.3924 35.5774 18.3924C34.1322 18.4766 32.9037 18.4285 32.9037 18.2961C32.9037 17.9351 33.3975 17.2011 33.7107 17.0928C34.1442 16.9244 34.0961 16.9364 34.6139 17.0688Z"
                    fill="white" />
                <path
                    d="M29.4588 24.541C28.9289 24.6854 28.3749 25.3592 28.1461 26.1173C27.857 27.0919 27.6884 29.2338 27.7727 30.9064C27.9413 34.3357 28.6158 35.5871 30.2176 35.4307C31.3015 35.3344 31.8796 34.6365 32.1566 33.1084L32.265 32.4827L31.6869 32.4105C31.3738 32.3623 31.0607 32.3623 31.0004 32.3984C30.9402 32.4345 30.8559 32.7233 30.8077 33.0482C30.7114 33.8183 30.5187 34.071 30.0731 34.0108C29.7961 33.9868 29.6636 33.8664 29.4709 33.4934C29.2541 33.0482 29.23 32.7714 29.23 29.8836C29.23 27.2363 29.2661 26.6828 29.4227 26.3218C29.8563 25.3833 30.6512 25.7683 30.7957 26.9837L30.88 27.6575L31.3858 27.5853C32.1326 27.477 32.1807 27.4529 32.1807 27.0799C32.1807 25.9849 31.434 24.7576 30.6391 24.529C30.1212 24.3846 29.9647 24.3966 29.4588 24.541Z"
                    fill="white" />
                <path
                    d="M10.9834 25.311V25.9728H11.706H12.4287L12.4527 30.6296L12.4889 35.2863L12.9465 35.2742C13.9943 35.2502 13.8739 35.8277 13.8739 30.6055V25.9728H14.5965H15.3192V25.311V24.6492H13.1513H10.9834V25.311Z"
                    fill="white" />
                <path
                    d="M16.6686 29.9678L16.7048 35.2863L17.331 35.3103L17.9693 35.3464L17.9934 32.9158L18.0296 30.4852H18.3307C18.6197 30.4852 18.6438 30.5453 19.1256 32.8075C19.4026 34.083 19.6555 35.1539 19.6916 35.19C19.7277 35.2261 20.0288 35.2742 20.3661 35.2983C20.8719 35.3224 20.9803 35.2983 20.9803 35.1298C20.9803 35.0215 20.7394 33.8544 20.4504 32.5308C19.9325 30.2325 19.9204 30.1122 20.1252 29.8835C20.9682 28.9209 21.185 26.8994 20.5708 25.7683C20.0409 24.8177 19.6675 24.6493 17.9693 24.6493H16.6445L16.6686 29.9678ZM18.969 25.9608C19.3785 26.1173 19.5712 26.767 19.511 27.7778C19.4507 28.8126 19.1496 29.2217 18.427 29.2217H17.9693V27.5371V25.8525H18.3186C18.5113 25.8525 18.8124 25.9007 18.969 25.9608Z"
                    fill="white" />
                <path
                    d="M23.6293 24.7336C23.6293 24.7937 23.2801 26.9717 22.8465 29.5828C22.425 32.1939 22.0636 34.5524 22.0395 34.8171L22.0034 35.2984H22.5333C23.1114 35.2984 23.3885 35.1179 23.3885 34.7569C23.3885 34.6246 23.4487 34.1192 23.5209 33.6138L23.6534 32.7114H24.364C25.1709 32.7114 25.1228 32.6392 25.3155 34.1553C25.3998 34.7208 25.472 35.1901 25.4841 35.2021C25.5684 35.2984 26.7487 35.3586 26.7968 35.2743C26.8571 35.1781 26.7487 34.4681 25.7249 28.1028L25.1589 24.6494H24.4001C23.9786 24.6494 23.6293 24.6855 23.6293 24.7336ZM24.4724 27.7779C24.4724 28.0907 24.7253 30.0762 24.8939 31.0508C24.9421 31.3757 24.9301 31.3877 24.3881 31.3877H23.8341L23.9063 30.75C23.9425 30.4131 24.0388 29.4866 24.1231 28.7165C24.2074 27.9464 24.3279 27.3447 24.376 27.3688C24.4242 27.4049 24.4724 27.5854 24.4724 27.7779Z"
                    fill="white" />
                <path
                    d="M33.6501 29.9678L33.6862 35.2983H35.6132H37.5402L37.5763 34.6004L37.6125 33.9146H36.3358H35.0712V32.1096V30.3047H35.9745H36.8778V29.6429V28.9811H35.9745H35.0712V27.477V25.9729H36.2033H37.3355L37.3836 25.3111L37.4198 24.6493H35.5169H33.626L33.6501 29.9678Z"
                    fill="white" />
                <path
                    d="M43.634 30.5455C43.5858 30.5816 43.4774 30.7621 43.4172 30.9666C43.345 31.1592 43.2486 31.4239 43.2004 31.5322C43.1161 31.7367 43.2607 31.7488 45.2117 31.7488H47.3194L47.4519 31.2795C47.5362 31.0268 47.5964 30.7621 47.5964 30.6899C47.5964 30.5575 43.8147 30.4252 43.634 30.5455Z"
                    fill="white" />
                <path
                    d="M41.8399 34.2395C41.4907 34.8051 41.2378 35.2984 41.2618 35.3225C41.298 35.3586 44.3089 35.3827 45.5615 35.3586C45.7421 35.3586 45.8987 35.0939 46.4648 33.8184L46.7538 33.1927H44.61H42.4662L41.8399 34.2395Z"
                    fill="white" />
            </svg>
        </div>
    </footer>
</div>